import { Box, Typography } from "@mui/material";
import React from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  cloneCycle,
  getAllEvaluationcycle,
} from "../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";

const CloneCycle = ({ open, setOpen, id }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.appraisal);

  const handleClone = () => {
    dispatch(cloneCycle(id)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        setOpen(false);
        dispatch(getAllEvaluationcycle());
      } else if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      }
    });
  };
  return (
    <Box>
      <GlobalDialog
        open={open}
        setOpen={setOpen}
        title={"Clone Cycle"}
        closeButton={true}
        fullWidth
        maxWidth={"xs"}
        content={
          <>
            <Typography>
              Are you sure ? you want to clone this cycle...!
            </Typography>
          </>
        }
        actionButton={
          <>
            <CancelButton size={"small"} action={() => setOpen(false)}>
              Cancel
            </CancelButton>
            <SubmitButton
              action={handleClone}
              disabled={loading}
              size={"small"}
            >
              {loading ? "Please Wait..." : "Clone"}
            </SubmitButton>
          </>
        }
      />
    </Box>
  );
};

export default CloneCycle;
